import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { ref, reactive, toRefs, computed, onMounted, getCurrentInstance } from "vue";
import apis from "@/api";
import { srcType } from "@/utils/srcType";
import { Plus, UploadFilled } from '@element-plus/icons-vue';
import UploadCopyright from "./UploadCopyright";
import SensitiveWords from "./SensitiveWords";
export default {
  name: "UpLoad",
  components: {
    SensitiveWords,
    UploadCopyright,
    Plus,
    UploadFilled
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    uploadData: {
      type: Object
    }
  },
  setup(props, context) {
    const {
      ctx
    } = getCurrentInstance();
    const data = reactive({
      sensWordsList: [],
      assetsIds: '',
      uploading: false,
      subUploading: 0,
      copyrightId: '',
      fileList: [],
      user: {}
    });
    const upload = ref(null);
    const copyrightRef = ref(null);
    const handleRemove = (file, fileList) => {
      console.log(file, fileList);
    };
    const handleSuccess = (response, file, fileList) => {
      console.log(response, file, fileList);
    };
    //上传前校验
    const beforeUpload = file => {
      console.log("before-upload", file);
      // fileCheck(file)
    };
    const fileCheck = file => {
      //类型：图片jpg/jepg/bmp/gif/png 音频mp3/wav 视频mp4 源文件PSD/AI/C4D 其他*application/x-c4t
      const checkType = props.uploadData.srcTyp ? srcType[props.uploadData.srcTyp].typ : '未知类型';
      //后缀
      const checkSuffix = props.uploadData.srcTypSuffix;

      //大小
      const checkSize = props.uploadData.picFileSize ? props.uploadData.picFileSize : 2097152000;

      //尺寸
      const checkFileSize = props.uploadData.picSize ? props.uploadData.picSize : "7680*4320";
      const arr = checkFileSize.split("*");
      const checkFileWidth = arr[0];
      const checkFileHeight = arr[1];

      //类型格式判断
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/x-bmp' || file.type === 'image/gif';
      const isAudio = file.type === 'audio/mp3' || file.type === 'audio/wav';
      const isVideo = file.type === file.type === 'video/mpeg4';
      const isOriginFile = file.type === 'application/postscript' || file.type === 'application/x-c4t';
      const isOther = file.type === 'application/pdf' || file.type === 'application/msword' || file.type === 'application/vnd.ms-powerpoint' || file.type === 'text/plain';
      const isLt2M = file.size / 1024 < checkSize;
      switch (checkType) {
        case "图片":
          if (!isImg) {
            ElMessage.error("失败!上传" + checkType + "类型不对!");
            return false;
          }
          break;
        case "音频":
          if (!isAudio) {
            ElMessage.error("失败!上传" + checkType + "类型不对!");
            return false;
          }
          break;
        case "视频":
          if (!isVideo) {
            ElMessage.error("失败!上传" + checkType + "类型不对!");
            return false;
          }
          break;
        case "源文件":
          if (!isOriginFile) {
            ElMessage.error("失败!上传" + checkType + "类型不对!");
            return false;
          }
          break;
        case "其他":
          if (!isOther) {
            ElMessage.error("失败!上传" + checkType + "类型不对!");
            return false;
          }
          break;
        default:
          break;
      }

      //大小判断
      if (!isLt2M) {
        ElMessage.error("失败!上传大小不对,不能超过" + checkSize + "kb!");
        return false;
      }

      //尺寸判断
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        //让页面中的img标签的src指向读取的路径
        var img = new Image();
        img.src = reader.result;
        if (img.complete) {
          //如果存在浏览器缓存中
          if (img.width > checkFileWidth || img.height > checkFileHeight) {
            ElMessage.error("失败!上传图片分辨率建议" + checkFileWidth + "*" + checkFileHeight + "以下!");
            return false;
          }
        } else {
          img.onload = function () {
            if (img.width > checkFileWidth || img.height > checkFileHeight) {
              ElMessage.error("失败!上传图片分辨率建议" + checkFileWidth + "*" + checkFileHeight + "以下!");
              return false;
            }
          };
        }
      };
      return isImg && isLt2M;
    };
    const submitUpload = async () => {
      data.uploading = true;
      await upload.value.submit();
      if (!data.fileList || data.fileList.length <= 0) {
        data.uploading = false;
        ElMessage.error('请选择素材文件');
        return;
      }
      if (copyrightRef.value) {
        await copyrightRef.value.submit();
        if (!data.copyrightId) {
          data.uploading = data.subUploading;
          return;
        }
      }
      const formData = new FormData();
      data.fileList.forEach(f => {
        formData.append('fileList', f);
      });
      formData.append("demandId", props.uploadData.demandId);
      formData.append("demandName", props.uploadData.demandName);
      formData.append('bucketName', 'outer-for-inner');
      apis.upload(formData).then(res => {
        console.log("res: ", res);
        if (res.success && res.data && res.data.length > 0) {
          const srcs = [];
          const sensList = [];
          res.data.forEach(file => {
            const src = {
              copyrightId: data.copyrightId,
              srcId: file.id,
              srcName: file.fileName,
              demandId: props.uploadData.demandId,
              demandName: props.uploadData.demandName,
              positionId: props.uploadData.positionId,
              positionTopId: props.uploadData.positionTopId,
              bgnDate: props.uploadData.bgnDate,
              endDate: props.uploadData.endDate,
              srcTyp: file.fileType,
              extension: file.extension,
              srcInnUrl: file.relativeUrl,
              srcOutUrl: '',
              createTime: file.uploadTime,
              srcSize: file.fileResolution,
              srcFileLength: file.size
            };
            console.log("upload src--->", src);
            srcs.push(src);
            let sens = {};
            sens.assetsId = file.id;
            sens.assetsContent = file.relativeUrl;
            sens.assetsName = file.fileName;
            for (let sw of data.sensWordsList) {
              if (sw.assetsName == src.srcName) {
                sens.sensitiveWords = sw.sensitiveWords;
              }
            }
            sensList.push(sens);
          });
          apis.saveAsws(sensList);
          apis.uploadSrcs(srcs).then(res => {
            if (res.success) {
              data.fileList = [];
              context.emit('success');
              ElMessage({
                type: 'success',
                message: '素材上传成功'
              });
              data.sensWordsList = [];
              context.emit('update:visible', false);
            } else {
              ElMessage.error(res.msg);
            }
          });
        } else {
          ElMessage.error('素材上传失败');
        }
      }).finally(() => {
        data.uploading = false;
        data.copyrightId = '';
      });
    };
    const checkSensitive = file => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        apis.checkSwByBase64({
          imgBase64: e.target.result
        }).then(res => {
          if (res.code == 200 && res.data) {
            data.sensWordsList.push({
              assetsName: file.name,
              sensitiveWords: res.data
            });
          }
        });
      };
    };
    const fileUpload = params => {
      checkSensitive(params.file);
      data.fileList.push(params.file);
      let fileNames = [];
      let files = [];
      a: for (const f of data.fileList) {
        let n = f.name;
        b: for (const name of fileNames) {
          if (name == f.name) {
            continue a;
          }
        }
        fileNames.push(n);
        files.push(f);
      }
      data.fileList = files;
    };
    const close = () => {
      upload.value.submit();
      data.fileList = [];
      data.sensWordsList = [];
      context.emit('update:visible', false);
    };
    return {
      ...toRefs(data),
      upload,
      copyrightRef,
      beforeUpload,
      handleRemove,
      handleSuccess,
      submitUpload,
      fileUpload,
      close
    };
  }
};